export default {
      id: "notifications__distance_geopoint-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__distance_geopoint",
      toString: function () {
        return this.url;
      }
    }